





























































































































































































































import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import {
  CANT_SEE_SECTION_MSG,
  CompanyID,
    formatDate,
    formatList,
    getCurrentTimestamp,
    getIndexFromList,
    getPropertyFromList,
    ID, matchedIndexIdInArray, OptionalCompany, parameterValueValidation, PRIVILEGE_KEYS, PRIVILEGE_TYPES, sortObjectByPropertyName,
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper,
    VehicleCompanyStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';

@Component({
    components: {
        Loading,
        Combobox,
        Button,
        SectionTitle,
        MultipleSelect,
        Input
    }
})
export default class ModalCsvWizard extends Mixins(
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper,
    VehicleCompanyStoreHelper
) {
    @Prop({default: undefined}) firstLineCsv: string | undefined;
    @Prop({default: []}) fileRows: string[];
    columnsOptions: Array<object> = [];
    separatorTypes: string[] = [',', '.', ';', ':']
    unityPefOptions: Array<object> = [];
    decimalSeparatorOptions: Array<object> = [
        {
            id: 0,
            value: 'punto',
            type: this.separatorTypes[1]
        },
        {
            id: 1,
            value: 'coma',
            type: this.separatorTypes[0]
        },
    ];
    separatorOptions: Array<object> = [
        {
            id: 0,
            value: 'coma',
            type: this.separatorTypes[0]
        },
        {
            id: 1,
            value: 'punto',
            type: this.separatorTypes[1]
        },
        {
            id: 2,
            value: 'punto y coma',
             type: this.separatorTypes[2]
        },
        {
            id: 3,
            value: 'dos puntos',
            type: this.separatorTypes[3]
        }
    ];
    datesOptions: Array<object> = [
        {
            id: 0,
            value: '%m/%d/%Y %I:%M:%S %p',
            example: '08/31/2022 04:45:09 PM'
        },
        {
            id: 1,
            value: '%d/%m/%Y - %H:%M:%S',
            example: '02/12/2022 - 20:10:06'
        },
        {
            id: 2,
            value: '%d/%m/%Y',
            example: '30/03/2022'
        },
        {
            id: 3,
            value: '%d-%m-%Y',
            example: '30-03-2022'
        },
        {
            id: 4,
            value: '%Y-%m-%dT%H:%M:%S',
            example: '2022-12-30T20:15:04'
        },
        {
            id: 5,
            value: '%Y/%m/%d',
            example: '2022/12/30'
        },
        
    ];
    separatorSelected: object | null = null;
    separatorSelectedRv: boolean = false;
    uploadingCsv: boolean = false;
    separatorDecimalSelected: object | null = null;
    separatorDecimalSelectedRv: boolean = false;
    appendFile: boolean = false;
    dateSelected: object | null = null;
    dateSelectedRv: boolean = false;
    exeXSelected: object | null = null;
    ejeXSelectedRv: boolean = false;
    exeYSelected: object | null = null;
    ejeYSelectedRv: boolean = false;
    perfSelected: object | null = null;
    perfSelectedRv: boolean = false;
    humSelected: object | null = null;
    humSelectedRv: boolean = false;
    dateColumn: object | null = null;
    dateColumnRv: boolean = false;
    unityPerfSelected: object | null = null;
    unityPerfSelectedRv: boolean = false;
    modalTitle: string = 'Cargar CSV';
    errorMsg: string = '';

    setErrorForm(value){
        this.errorMsg = value;
    }

    get getDetectedColumns(){
        if(this.columnsOptions.length == 0){
            return '-'
        }
        return this.columnsOptions.map(function(col){
            return col['value']
        }).join(', ')
    }

    @Watch('$_getInsuranceProperties', { immediate: true, deep: true })
    observableProperties() {
        this.assignPropertiesData();
    }
    
    updateSeparatorSelected(item){
        if(item !== null){
            this.updateColumnsTypes(item['value']);
            this.autoSelectFields();
        }else{
            this.resetColumnsValues();
        }
        this.separatorSelected = item;
    }
    updateSeparatorSelectedRv(value){
        this.separatorSelectedRv = value;
    }
    updateSeparatorDecimalSelected(value){
        this.separatorDecimalSelected = value;
    }
    updateSeparatorDecimalSelectedRv(value){
        this.separatorDecimalSelectedRv = value;
    }
    updateDateSelected(value){
        this.dateSelected = value;
    }
    updateDateSelectedRv(value){
        this.dateSelectedRv = value;
    }
    updateEjeXSelected(value){
        this.exeXSelected = value;
    }
    updateEjeXSelectedRv(value){
        this.ejeXSelectedRv = value;
    }
    updateEjeYSelected(value){
        this.exeYSelected = value;
    }
    updateEjeYSelectedRv(value){
        this.ejeYSelectedRv = value;
    }
    updatePerfSelected(value){
        this.perfSelected = value;
    }
    updatePerfSelectedRv(value){
        this.perfSelectedRv = value;
    }
    updateHumSelected(value){
        this.humSelected = value;
    }
    updateHumSelectedRv(value){
        this.humSelectedRv = value;
    }
    updateDateColumn(value){
        this.dateColumn = value;
    }
    updateDateColumnRv(value){
        this.dateColumnRv = value;
    }
    updateUnityPerfSelected(value){
        this.unityPerfSelected = value;
    }
    updateUnityPerfSelectedRv(value){
        this.unityPerfSelectedRv = value;
    }

    resetColumnsValues(){
        this.updateEjeXSelected(null);
        this.updateEjeYSelected(null);
        this.updatePerfSelected(null);
        this.updateUnityPerfSelected(null);
        this.updateHumSelected(null);
        this.updateDateColumn(null);
    }

    customLabelDateField(option) {
        return `${option.value} - (${option.example})`;
    }

    @Emit()
    closeModal() {}

    @Emit()
    prevStep() {}

    @Emit()
    uploadCsv(data) {return data}

    getData(){
        return {
            separator: this.separatorSelected ? this.separatorSelected['type'] : '',
            decimal_separator: this.separatorDecimalSelected ? this.separatorDecimalSelected['type'] : '',
            timestamp_format: this.dateSelected ? this.dateSelected['value'] : '',
            x_column: this.exeXSelected ? this.exeXSelected['value'] : '',
            y_column: this.exeYSelected ? this.exeYSelected['value'] : '',
            timestamp_column: this.dateColumn ? this.dateColumn['value'] : '',
            perf_column: this.perfSelected ? this.perfSelected['value'] : '',
            hum_column: this.humSelected ? this.humSelected['value'] : '',
            perf_unit: this.unityPerfSelected ? this.unityPerfSelected['id'] : '',
            append: this.appendFile
        }
    }

    submitCsv(){
        let dataToSubmit = this.getData();
        this.uploadCsv(dataToSubmit)
        
    }

    
    mounted() {
        let self = this;
        this.$nextTick(() => {
            self.assignPropertiesData();
            self.updateSeparatorSelected(self.separatorOptions[0]);
            self.autoSelectFields();
            
        });
         
        // console.log("modal wizard", this.firstLineCsv);
        // console.log("modal wizard this.$_getInsuranceProperties", this.$_getInsuranceProperties);
    }

    autoSelectFields(){
        this.updateSeparatorDecimalSelected(this.decimalSeparatorOptions[0]);
        this.updateEjeXSelected(this.getExactValue('X'));
        this.updateEjeYSelected(this.getExactValue('Y'));
        this.updateHumSelected(this.getValueInColumns(['moisture', 'humidity', 'hum']));
        this.updatePerfSelected(this.getValueInColumns(['perf', 'mass']));
        this.updateDateColumn(this.getValueInColumns(['date', 'time']))
    }


    getExactValue(value: string){
        let index = this.columnsOptions.findIndex(item => item['value'].toLowerCase() == value.toLowerCase());
        if(index !== -1){
            return this.columnsOptions[index]
        }
        return null
    }

    getValueInColumns(values: string[]){
        let indexMatchInList = -1;
        for (let index = 0; index < values.length; index++) {
            const currentValue = values[index].toLowerCase();
            indexMatchInList = (this.columnsOptions.findIndex(function(item){
                return item['value'].toLowerCase().indexOf(currentValue)!==-1;
            }));
            if(indexMatchInList !== -1){
               break
            }
        }
        if(indexMatchInList !== -1){
            return this.columnsOptions[indexMatchInList]
        }
        return null
    }



    updateColumnsTypes(separatorSelected: string){
        switch(separatorSelected){
            case 'coma':
                this.setColumnsBySeparator(',')
                break;
            case 'punto':
                this.setColumnsBySeparator('.')
                break
            case 'punto y coma':
                this.setColumnsBySeparator(';')
                break
        }
    }

    setColumnsBySeparator(separator: string){
        //separator = , . ;
        let columns:Array<object> = [];
        if(this.firstLineCsv){
            //a la primera linea del archivo le hago un split 
            //por el separador seleccionado para generar la lista de columnas
            this.firstLineCsv =  this.firstLineCsv.replace(/(\r\n|\n|\r)/gm, "");
            let fileColumns = this.firstLineCsv.split(separator);

            // console.log("Columns by separator", fileColumns)

            if(fileColumns.length > 0){
                columns = fileColumns.map(function(column, index){
                    return {
                        id:index,
                        value: column
                    }
                })
            }
        }
        this.columnsOptions = columns;
    }

    assignPropertiesData(){
        this.unityPefOptions = this.$_getInsuranceProperties['performance_units'];
    }

    get formIsValid() {
        this.setErrorForm('')
        if(this.separatorSelected == null){
            this.setErrorForm('No seleccionó el Separador')
            return false
        }
        if(this.separatorDecimalSelected == null){
            this.setErrorForm('No seleccionó el Separador Decimal')
            return false
        }
        if(this.exeXSelected == null){
            this.setErrorForm('No seleccionó la columna Eje X')
            return false
        }
        if(this.exeYSelected == null){
            this.setErrorForm('No seleccionó la columna Eje Y')
            return false
        }
        if(this.perfSelected == null){
            this.setErrorForm('No seleccionó la columna de Rendimiento')
            return false
        }
        if(this.unityPerfSelected == null){
            this.setErrorForm('No seleccionó la unidad Rendimiento')
            return false
        }
        if(this.humSelected == null){
            this.setErrorForm('No seleccionó la columna de Humedad')
            return false
        }
        if(this.dateColumn == null){
            this.setErrorForm('No seleccionó la columna de Fecha')
            return false
        }
        if(this.dateSelected == null){
            this.setErrorForm('No seleccionó el formato de Fecha')
            return false
        }
        return true
    }

    
}
